import React, {useEffect, useState} from 'react';
import { Container, Grid, Button, Typography, Box, List, Rating , ListItem,  } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';

import { Link } from 'react-router-dom';
import abushadi from '../assests/images/abushadi-2.png';
import abushadi2 from '../assests/images/chef.adel.jpg';
import abushadi3 from '../assests/images/chef2.jpg';
import abushadi4 from '../assests/images/chef2.jpg';
import hat from "../assests/images/hat.png"
import plate from "../assests/images/plate.png"
import list from "../assests/images/list.png"
import pan from "../assests/images/pan.png"
import bg from '../assests/images/bg.jpg';
import {useTheme, useMediaQuery } from '@mui/material';
import img1 from "../assests/images/home-img1.png"
import img2 from "../assests/images/appetizers-0.jpg"
import img3 from "../assests/images/kebah-2.jpg"
import img4 from "../assests/images/kebab2.jpg"
import img5 from "../assests/images/chef-decorating-carrots.jpg"
import img6 from "../assests/images/top-view-of-slices-of-grilled-beef-with-potato-pi-2022-04-01-23-02-17-utc.png"
import img7 from "../assests/images/hummus.jpg"
import img8 from "../assests/images/appetizers9.jpg"
import img9 from "../assests/images/appetizers5.jpg"
import img10 from "../assests/images/kafta.jpg"
import img11 from "../assests/images/kebb.jpg"
import img12 from "../assests/images/sambosak.jpg"
import img13 from "../assests/images/mixedkebab.jpg"
import img14 from "../assests/images/mankousha.jpg"
import img15 from "../assests/images/labm.jpg"
import img16 from "../assests/images/keba.jpg"
import { BsRecycle } from "react-icons/bs";
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import { GoChecklist } from "react-icons/go";
import { GiChefToque } from "react-icons/gi";
import { useDBPosts  } from '../contexts/DBPostsContext'; // Import PostContext

import Post from './Post';


import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
export default function Home() {
    const theme = useTheme();
    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
    const { posts, toggleFavoritePost, fetchPosts } = useDBPosts(); // Add fetchPosts to your context

    const reviews = [
      {
        rating: 5,
        review: "Adel's culinary expertise is unmatched. The fusion of flavors in his dishes always leaves a lasting impression. His leadership transformed our kitchen and boosted restaurant efficiency.",
        reviewerName: 'Sara A.',
        reviewerRole: 'Restaurant Owner',
      },
      {
        rating: 5,
        review: "Working with Adel was a game-changer for my restaurant. He revamped our entire menu, introduced waste management systems, and elevated our dining experience. Highly recommended for any restaurant in need of a boost!",
        reviewerName: 'Mohammed Z.',
        reviewerRole: 'Restaurant Consultant',
      },
      {
        rating: 4,
        review: "Adel’s attention to detail is impeccable. From menu creation to staff training, his guidance has been invaluable. Our profits have soared, and waste has been cut significantly!",
        reviewerName: 'Leila B.',
        reviewerRole: 'Restaurant Manager',
      },
      {
        rating: 5,
        review: "Adel’s passion for cooking is contagious! His innovative approach to menu development has drawn in new customers and turned our restaurant into a hotspot. His expertise in Middle Eastern cuisine is simply brilliant.",
        reviewerName: 'Omar H.',
        reviewerRole: 'Head Chef',
      },
      {
        rating: 4,
        review: "We saw incredible results after Adel's consultancy. His waste reduction strategies helped us increase our profit margins, and his training transformed our kitchen team.",
        reviewerName: 'Jessica M.',
        reviewerRole: 'Culinary Consultant',
      },
      {
        rating: 5,
        review: "Adel’s ability to create vibrant, delicious dishes while optimizing restaurant operations is extraordinary. His knowledge of Italian and French cuisine is particularly impressive!",
        reviewerName: 'Pascal R.',
        reviewerRole: 'Restaurant Critic',
      },
    ];
    

  


    
        const sliderSettings = {
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 960, // For tablets
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 600, // For mobile
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        };

    
  return (
    
   <>
    <Grid 
      container 
      component="main" 
      
      sx={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        paddingY: '4rem'
      }}
    >
      {/* Background overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#fceade',
          opacity: 0.8,
          zIndex: 1,
        }}
      />

      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={6}
        sx={{
          zIndex: 2, // Ensure it's on top of the overlay
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: {md: 'auto', xs:'2rem'}
        }}

      >
     
    

     <CardMedia
    component="img"  // This tells CardMedia to act like an img element
    alt="Chef Abu Shadi" 
    image={abushadi2} 
    sx={{ 
      width: { md: 500, sm: '100%' },
      height: 'auto' // Ensure the height adjusts automatically
    }} 
  />
      </Grid>

      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={6} 
        component={Box} 
        sx={{ 
          zIndex: 2, // Ensure content is on top of overlay
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          padding: 3 
        }}
      >
        <Grid>

        <Typography component="h6" variant="h6" align="center" mb={1} className='heading' >
        Chef de cuisine - Mastering the Art of Culinary Innovation and Restaurant Success
        </Typography>
        <Typography component="h3" variant="h3" align="center" mb={1} className='sub-heading'>
        13+ Years of Global Culinary Excellence and Restaurant Management Expertise
       
        </Typography>

        </Grid>
        <Grid   container >

        
        <Grid item xs ={12} sm ={12} md={6} sx={{display: 'flex', alignItems: 'center'}} >
        
        <Typography component="p" align="start"  my={1} className='body'>
        Adel Aljaadi – Renowned Chef and Restaurant Management Specialist with extensive experience in Italian, French, Middle Eastern, and Turkish cuisines.        </Typography>
       

        </Grid>
        <Grid item xs ={12} sm ={12} md={6} marginTop={!isSmUp ? '2rem' : ''}>
        <img src={img1} style ={{width:"250px"}} alt="" />
        </Grid>

        </Grid>
        <Grid item xs ={12} sm ={12} md={6}>
        <Link to="/about"   class="button-48" role="button"><span class="text">Explore My Culinary Journey</span></Link>
        </Grid>
        


       
      </Grid>
    </Grid>
    <Grid 
    container
        sx={{ 
            zIndex: 2, // Ensure content is on top of overlay
            display: 'flex', 
         
            justifyContent: 'center', 
            alignItems: 'center',
            padding: isSmUp? '2rem 4rem' : "2rem 1rem" 

          }}

    >

    <Grid 
        item 
        xs={12} 
        sm={12} 
        md={6} 
    
        sx={{ 
          zIndex: 2, // Ensure content is on top of overlay
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'start', 
          padding: 3 
        }}
      >
      <Typography component="p" variant="p"  align="start" mb={1} className='heading' >
      Finest Culinary Delights
      
    </Typography>
    <Typography component="h4" variant="h4" align="start" mb={1} className='sub-heading' >
    Elevate Your Culinary Journey <br /> With Bespoke Creations by Chef Abu Shadi
      
    </Typography>
    </Grid>
    <Grid
     item 
     xs={12} 
     sm={12} 
     md={6} 
     sx={{ 
        zIndex: 2, // Ensure content is on top of overlay
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'start', 
        padding: 3 
      }}
    >
    <Typography component="p" align="start" mb={1} className='body'>
    Discover a world of flavors crafted exclusively for you. From intimate gatherings to grand celebrations, Chef Abu Shadi brings passion, creativity, and a personalized touch to every dish, ensuring your dining experience is unforgettable and tailored to your desires.
    </Typography>
    </Grid>
    <Grid
     container
     rowSpacing={2}
     sx={{ 
        zIndex: 2, // Ensure content is on top of overlay
       display: 'flex',
        justifyContent: 'start', 
        padding: 3 
      }}
    >
          <Grid
              item 
              xs={12} 
              sm={12} 
              md={4} 
              sx={{ 
               display: 'flex',
                justifyContent: 'center', 
               
              }}
          >
            <img src={img2} style={{width: '200px', height: '300px'}} alt="" />
          </Grid>
          <Grid
              item 
              xs={12} 
              sm={12} 
              md={4} 
              sx={{ 
                display: 'flex',
                 justifyContent: 'center', 
                
               }}
          >
            <img src={img3} style={{width: '300px'}} alt="" />
          </Grid>
          <Grid
              item 
              xs={12} 
              sm={12} 
              md={4} 
              sx={{ 
               
                display: 'flex',
                justifyContent: 'center', 
                
               }}
          >
            <img src={img4} style={{width: '200px', height: '300px'}} alt="" />
            </Grid>
    </Grid>
    </Grid>
    

               {/* services section */}
    <Grid 
      container 
      component="main" 
      
      sx={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        padding: isSmUp? '2rem 4rem' : "2rem 1rem" 
      }}
    >
      {/* Background overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#fceade',
          opacity: 0.8,
          zIndex: 1,
        }}
      />

     

      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={12} 
        component={Box} 
        sx={{ 
          zIndex: 2, // Ensure content is on top of overlay
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          padding: 3 
        }}
      >
        <Grid marginBottom="3rem">

        <Typography component="h6" variant="h6" align="center" mb={1} className='heading' >
        Offered Services
        </Typography>
        <Typography component="h3" variant="h3" align="center" mb={1} className='sub-heading'>
        Providing Exceptional Service Creating <br/> Remarkable Dishes
       
        </Typography>
        </Grid>

        <Grid
        container
        component={Box}
        columnSpacing={5}
        sx={{
          
            display: 'flex',
            
            justifyContent: 'center',
            alignItems: 'start',
            
        }}
        >

       
        <Grid 
          item 
          xs={12} 
          sm={12} 
          md={3} 
          mb={3}
        >
                 <RestaurantMenuIcon className='icon' />
        <Typography component="h6" variant="h6" align="start" mt={2} className='sub-heading-2'>
        Menu Development & Culinary Innovation
        </Typography>
        <Typography component="p" variant="p" align="start"  className='body'>
        A great menu is the heart of every successful restaurant. With my experience across Italian, French, Middle Eastern, and Turkish cuisines, I specialize in developing menus that not only excite your customers but also maximize profitability.      
        </Typography>
        </Grid>
        
        <Grid 
          item 
          xs={12} 
          sm={12} 
          md={3} 
          mb={3}
        >
        <GoChecklist  className='icon' />
        <Typography component="h6" variant="h6" align="start" mt={2} className='sub-heading-2'>
        Restaurant Consulting & Management
        </Typography>
        <Typography component="p" variant="p" align="start"  className='body'>
        Struggling to take your restaurant to the next level? I provide expert restaurant consulting services, focusing on maximizing profits, reducing waste, and optimizing operations.  
        </Typography>
        </Grid>
        <Grid 
          item 
          xs={12} 
          sm={12} 
          md={3} 
          mb={3}
        >
       <GiChefToque   className='icon' />
        <Typography component="h6" variant="h6" align="start" mt={2} className='sub-heading-2'>
        Comprehensive Staff Training & Development
        </Typography>
        <Typography component="p" variant="p" align="start"  className='body'>
        Your team is the backbone of your restaurant’s success. I offer hands-on staff training to improve skills, efficiency, and customer service.  
        </Typography>
        </Grid>
        <Grid 
          item 
          xs={12} 
          sm={12} 
          md={3} 
       
        >
        <BsRecycle className='icon' />
        <Typography component="h6" variant="h6" align="start" mt={2} className='sub-heading-2'>
        Waste Reduction & Profit Maximization Solution
        </Typography>
        <Typography component="p" variant="p" align="start"  className='body'>
        My strategies for optimizing have been proven to lower waste rates to below 0%, allowing restaurants to save money and become more sustainable. Let me help you turn your kitchen waste into revenue and streamline your operations for greater profitability.        </Typography>
        </Grid>

        <Link to="/services" class="button-48" role="button" style={{marginTop: '5rem'}}><span class="text">view all services</span></Link >

        </Grid>
        


       
      </Grid>
    </Grid>


    {/* Culinary Specializations section */}

    <Grid 
      container 
      component="main" 
     sx={{
      padding: isSmUp? '2rem 4rem' : "2rem 1rem" 
     }}
    
    >
   

      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={6}
        sx={{
          zIndex: 2, // Ensure it's on top of the overlay
          display: 'flex',
          flexDirection: 'column',
          padding: 3 ,
          
          marginTop: 5,
        }}
      >
        <Typography component="h6" variant="h6" align="start" mb={1} className='heading' >
        Culinary Specializations
        </Typography>
        
        <Typography component="h3" variant="h3" align="start" mb={1} className='sub-heading'>
        Savor the Art of Fusion Creating <br/>  Memorable Dining Experiences    
       
        </Typography>
     

        <Typography component="p" align="start" mb={1} className='body'>
  <List
    sx={{
      listStyleType: 'square',
      listStylePosition: 'inside',
      '& li::marker': {
        color: '#ca7735', // Set bullet color to your desired color
      },
    }}
  >
    <ListItem sx={{ display: 'list-item', color: 'inherit' }}>
    Middle Eastern Cuisine 
    </ListItem>
    <ListItem sx={{ display: 'list-item', color: 'inherit' }}>
    Italian Cuisine
    </ListItem>
    <ListItem sx={{ display: 'list-item', color: 'inherit' }}>
    French Cuisine
    </ListItem>
    <ListItem sx={{ display: 'list-item', color: 'inherit' }}>
    Turkish Cuisine
    </ListItem>
    <ListItem sx={{ display: 'list-item', color: 'inherit' }}>
    Baking & Pastry of all mentioned cuisines
    </ListItem>
  </List>
</Typography>


<button class="button-48" role="button"><span class="text">Book a free consultation</span></button>



      </Grid>

     <Grid 
  item 
  xs={12} 
  sm={12} 
  md={6}
  sx={{
    zIndex: 2, // Ensure it's on top of the overlay
    display: 'flex',
    flexDirection: 'column',
 
    padding: 3,
    marginTop: 5,
    position: 'relative',  // Positioning for the children
  }}
>
  <Grid item sx={{position: 'relative'}}>
   
      <CardMedia
    component="img"  // This tells CardMedia to act like an img element
    alt="Chef Abu Shadi" 
    image={abushadi3} 
    sx={{ 
      width: { md: 500, sm: '100%' },
      height: 'auto' // Ensure the height adjusts automatically
    }} 
  />
  </Grid>
</Grid>

<Grid container>

</Grid>

<Box sx={{ width: '100%', mt: 5,  padding: '2rem', }}>
      <Slider {...sliderSettings}>
        {reviews.map((review, index) => (
          <Grid
            container
            spacing={2}
            key={index}
            justifyContent="center"
            alignItems="center"
            sx={{
             
              borderRadius: '10px',
              padding: '2rem',
              textAlign: 'center',
            }}
          >
            {/* Row 1: Rating Stars */}
           
              <Rating value={review.rating} readOnly precision={0.5} size="large" />
           

            {/* Row 2: Review Content */}
           
              <Typography variant="body1" sx={{ fontStyle: 'italic', marginY: 5, fontSize: '2rem', color: '#968b8b' }} className='sub-heading-2'>
               <q>

                {review.review}
               </q>
              </Typography>
           

            {/* Row 3: Reviewer Name */}
          
        <Typography variant="h6" sx={{ fontWeight: 'bold', }} className='sub-heading-2'>
            {review.reviewerName}
        </Typography>
     

        {/* Row 4: Reviewer Role */}
       
        <Typography variant="caption" color="textSecondary" sx={{ marginTop: 0 }}>
            {review.reviewerRole}
        </Typography>
       
          </Grid>
        ))}
      </Slider>
    </Box>


      
    </Grid>

    <Grid 
      container 
      component="main" 
      
      sx={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        padding: isSmUp? '2rem 4rem' : "2rem 1rem" 
      }}
    >
      {/* Background overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#fceade',
          opacity: 0.8,
          zIndex: 1,
        }}
      />

     

      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={12} 
        component={Box} 
        sx={{ 
          zIndex: 2, // Ensure content is on top of overlay
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          padding: 3,
        }}
      >
        <Grid marginBottom="3rem">

        <Typography component="h6" variant="h6" align="start" mb={1} className='heading' >
        
        Culinary Specialties
        </Typography>
        <Typography component="h3" variant="h3" align="start" mb={1} className='sub-heading'>
        Stay Up to Date with The Latest Food <br/> Trends, Recipes, and Cooking Techniques       
        </Typography>
       

        </Grid>
        <Grid container sx={{         
            position: 'relative',  // Positioning for the children
            display: 'flex',
         
            }}>
        <Grid items xs={12} md={3} 
        sx={{
            marginTop: '5rem'
        }}>
            <img src={img7} style={{width: '250px', marginBottom: '4rem'}} alt="" />
            <img src={img12} style={{width: '250px', marginBottom: !isSmUp ? '2rem' : '',}} alt="" />

        </Grid>
        <Grid items xs={12} md={3} >
            <img src={img8} style={{width: '250px', marginBottom: '2rem', }} alt="" />
            <img src={img16} style={{width: '250px'}} alt="" />

        </Grid>
        <Grid items xs={12} md={3} 
          sx={{
            marginTop: '3rem'
        }}
        >
            <img src={img11} style={{width: '250px', marginBottom: '1rem'}} alt="" />
            <img src={img10} style={{width: '250px', marginBottom: '1rem'}} alt="" />

            <img src={img13} style={{width: '250px'}} alt="" />
       
        </Grid>
        <Grid items xs={12} md={3} 
          sx={{
            marginTop: '7rem'
        }}
        >
            <img src={img15} style={{width: '250px', marginBottom: '3rem'}} alt="" />

            <img src={img14} style={{width: '250px'}} alt="" />
        </Grid>
        </Grid>

   
        


       
      </Grid>

   
    </Grid>

    <Grid container 
    sx={{    padding: isSmUp? '2rem 4rem' : "2rem 1rem" }}
        >
         <Grid marginBottom="3rem" padding={3}>

      <Typography component="h6" variant="h6" align="start" mb={1} className='heading' >

      Explore a World of Flavors 
      </Typography>
      <Typography component="h3" variant="h3" align="start" mb={1} className='sub-heading'>
      Discover Tantalizing Recipes, Expert Restaurant Tips, and Travel Inspiration! <br/> Your Culinary Journey Starts Here
      </Typography>

</Grid>

<Grid container sm={12} md={12} lg={12} padding={3}>


  {posts.slice(0, 3).map(post => {
    // Create a shallow copy of the post object without the `content` field
    const { content, ...postWithoutContent } = post;

    return (
      <Post
        key={post._id}
        postInfo={postWithoutContent}  // Pass the post data excluding content
      />
    );
  })}
</Grid>
<Grid item xs={12} md={12} padding={3} 
   sx={{
          
    display: 'flex',
    
    justifyContent: 'center',
    alignItems: 'center',
    
}}
            
            >

<Link to="/blog" class="button-48"  role="button"><span class="text">Discover more</span></Link>
</Grid>


</Grid>
    </>
  );
}
